import { useState, useRef, useEffect, useCallback } from 'react';

export function useContextMenus() {
  const [eventToCopy, setEventToCopy] = useState(null);

  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    event: null,
  });
  const contextMenuRef = useRef(null);

  const [slotContextMenu, setSlotContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    slot: null,
  });
  const slotContextMenuRef = useRef(null);

  const handleRightClickEvent = useCallback((event, e) => {
    if (event.approval_status === 'Marked') return;
    e.preventDefault();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      event,
    });
  }, []);

  const handleRightClickSlot = useCallback((slotInfo, e) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu({ visible: false, x: 0, y: 0, event: null });
    setSlotContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      slot: slotInfo,
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target)
      ) {
        setContextMenu({ visible: false, x: 0, y: 0, event: null });
      }

      if (
        slotContextMenuRef.current &&
        !slotContextMenuRef.current.contains(event.target)
      ) {
        setSlotContextMenu({ visible: false, x: 0, y: 0, slot: null });
      }
    };

    if (contextMenu.visible || slotContextMenu.visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [contextMenu.visible, slotContextMenu.visible]);

  return {
    eventToCopy,
    setEventToCopy,
    contextMenu,
    setContextMenu,
    contextMenuRef,
    slotContextMenu,
    setSlotContextMenu,
    slotContextMenuRef,
    handleRightClickEvent,
    handleRightClickSlot,
  };
}